<nav class="sideBarNav">
  <div class="sideBarTopBtn"   matTooltip="Scroll to top" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false" [libHoverColor]="theme.name === 'Plain' ? '#6590a7' : theme.color" (click)="scrollToMenu()">
    <i class="fal fa-fw fa-arrow-to-top"></i>
  </div>
  <div class="sideBarBtnSection" *ngIf="booted">
    <div class="sideBarBtn" [style.border-color]="theme.name === 'Plain' ? '#6590a7' : theme.color" *ngFor="let dm of pawneeDashConfs" [matTooltip]="dm.boxTitle + ' ' + dm.hotKey" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false" matTooltipPosition="right" [libHoverColor]="dm.boxMainColor" (click)="focusOnDash(dm.boxTitle)">
      <i class="fal fa-fw" [ngClass]="dm.boxMainIconClass"></i>
    </div>
  </div>
  <div class="sideBarBottomBtn">
    <div matTooltip="Dashboard settings" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false" [libHoverColor]="theme.color" (click)="openDashOptions()">
      <i class="fal fa-cog"></i>
    </div>
  </div>
</nav>

<main [class]="'dashWrapper mb-4 ' + theme.class" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}">
  <lib-dashboard #mainDashboard *ngIf="showDashboard"
    [user]="displayName"
    [modules]="pawneeDashModules"
    [confs]="pawneeDashConfs"
    [timeZoneOffset]="isDstObserved() ? userTimeZone.DSToffset : userTimeZone.offset"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
    (newRecordEmitter)="newRecordHandler($event)"
    (openRecordEmitter)="openRecordType($event)"
    (saveSettingsEmitter)="updateDashColor($event)"
    (saveDashConfEmitter)="saveDashConfig($event)"
    (sendMessageEmitter)="interceptMessageCommand($event)"
    (UIDQueueArrayEmitter)="updateUIDQueues($event)">
  </lib-dashboard>

  <div class="dashPaneSlide" [style.width]="contactPaneHandle.fullScreenMode ? '100%' : '900px'" [ngClass]="{'open': contactPaneHandle.isPaneOpen, 'fullScreen': contactPaneHandle.isPaneOpen && contactPaneHandle.fullScreenMode}" [style.border-color]="contactDashModule.boxMainColor">
    <lib-contactPane #contactPane *ngIf="contactPaneHandle.isPaneOpen"
      (closePaneEmitter)="closePane(contactDashModule.boxTitle)"
      [open]="contactPaneHandle.isPaneOpen"
      [recordUIDQueue]="getUIDQueueForModule(contactDashModule.boxTitle)"
      [theRecord]="contactPaneHandle.singlePaneData"
      [accentColor]="contactDashModule.boxMainColor"
      [contactTypeData]="preLoadContactTypes"
      [isAdmin]="isAdmin()"
      [lowLevel]="this.currentUser.hasPermissions('contactswrite')"
      [darkMode]="appGlobals.getStoredDarkModeSetting()"
      [glassMode]="appGlobals.getStoredGlassModeSetting()"
      [defaultBackgroundImgPath]="'../../assets/images/default_background.png'"
      [defaultIndividualAvatarPath]="'../../assets/images/bug_with_moon.png'"
      [defaultOrganizationAvatarPath]="'../../assets/images/bug_with_moon.png'"
      [mainDataService]="contactDashSvc"
      [userAccountDataService]="userSvc"
      (editUserEmitter)="manageUser($event)"
      (createUserEmitter)="promoteContactToUser($event)"
      (deleteUserEmitter)="deleteUser($event)"
      (shareDataEmitter)="handleShareContact($event)"
      (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
      (deleteDataEmitter)="deleteContact(contactPaneHandle.singlePaneData)"
      (deactivateConfirmEmitter)="deactivateDataConfirm($event)"
      (changingUIDEmitter)="updateActiveContactUID($event)"
      [fullScreenMode]="contactPaneHandle.fullScreenMode"
      (fullScreenModeEmitter)="contactPaneHandle.toggleFullScreen($event)"
      (requestStarbaseRecordEmitter)="closePane(contactDashModule.boxTitle); openRecordType($event)"
      [fileUploadDescription]="'1920x1080 max, 18MB max. Accepts .jpg .png .gif .tif; TIP: You can resize images with MS Paint.'"
      [timeZoneOffset]="contactDashModule.timeZoneOffset"
      [navTabsOverride]="contactPaneTabs"
      (requestRecordHistoryEmitter)="appComponent.handleRecordHistoryRequest($event)"
      (recordUpdatedEmitter)="contactUpdated()"
      (updateConfirmEmitter)="contactUpdateConfirm($event)"
      [webSocketSvc]="webSocketSvc"
      (sendMessageEmitter)="receiveSendMessage($event)">
      <ng-container ngProjectAs="contactPhones">
        <div class="ms-4">
          <lib-new-table-editor #contactPhonesTable
           modelName="Contact Phone"
            (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
            (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
            [tooltipDelay]="tooltipDelay"
            [usePagination]="false"
            [dataSvc]="contactPhoneSvc"
            [columns]="contactPhoneCols"
            [userViewOptions]="contactPhoneTableViewOpts"
            [loadAllClientside]="true"
            [darkMode]="appGlobals.getStoredDarkModeSetting()"
            [glassMode]="appGlobals.getStoredGlassModeSetting()">
            <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="contactPhoneCols" let-editRow="editRow" let-tableViewOptions="tableViewOptions">
              <span style="display: contents;" lib-table-row
                [rowData]="rowData"
                [columnDefinitions]="contactPhoneCols"
                [editRow]="editRow"
                [allowEdit]="true"
                [tableViewOptions]="tableViewOptions"
                [darkMode]="appGlobals.getStoredDarkModeSetting()"
                [glassMode]="appGlobals.getStoredGlassModeSetting()"
                (cancelEmitter)="contactPhonesTable.cancelChanges($event)"
                (selectedEmitter)="contactPhonesTable.changeEditMode(!editRow, rowData.uid)"
                (deleteEmitter)="contactPhonesTable.deleteRecordPressed($event)"
                (saveEmitter)="contactPhonesTable.saveChanges($event)"></span>
            </ng-template>
          </lib-new-table-editor>
        </div>
      </ng-container>
      <ng-container ngProjectAs="contactEmails">
        <div class="ms-4">
          <lib-new-table-editor #contactEmailsTable [hidden]="!emailLoaded"
            modelName="Contact Email"
            (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
            (deleteConfirmEmitter)="sbCmpMsgSvc.dataDeleteConfirm($event)"
            [tooltipDelay]="tooltipDelay"
            [usePagination]="false"
            [dataSvc]="contactEmailSvc"
            [columns]="contactEmailCols"
            [userViewOptions]="contactEmailTableViewOpts"
            [loadAllClientside]="true"
            [darkMode]="appGlobals.getStoredDarkModeSetting()"
            [glassMode]="appGlobals.getStoredGlassModeSetting()">
             <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="contactEmailCols" let-editRow="editRow" let-tableViewOptions="tableViewOptions">
                <span style="display: contents;" lib-table-row
                  [rowData]="rowData"
                  [columnDefinitions]="contactEmailCols"
                  [editRow]="editRow"
                  [allowEdit]="true"
                  [tableViewOptions]="tableViewOptions"
                  [darkMode]="appGlobals.getStoredDarkModeSetting()"
                  [glassMode]="appGlobals.getStoredGlassModeSetting()"
                  (cancelEmitter)="contactEmailsTable.cancelChanges($event)"
                  (selectedEmitter)="contactEmailsTable.changeEditMode(!editRow, rowData.uid)"
                  (deleteEmitter)="contactEmailsTable.deleteRecordPressed($event)"
                  (saveEmitter)="contactEmailsTable.saveChanges($event)"></span>
             </ng-template>
          </lib-new-table-editor>
        </div>
      </ng-container>
    </lib-contactPane>

    <div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="kioskPaneHandle.isPaneOpen" [style.color]="kioskPaneHandle.accentColor" style="width: 80%; height: auto; padding: 0;">
      <lib-kiosk-account-pane #kioskPane
        [accentColor]="kioskDashModule.boxMainColor"
        [iconClass]="kioskDashModule.boxMainIconClass"
        [iconColor]="kioskDashModule.boxMainColor"
        [boxMainColor]="kioskDashModule.boxMainColor"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [isAdmin]="isAdmin"
        [addMode]="kioskPaneHandle.addMode"
        [editMode]="kioskPaneHandle.editMode"
        [recordUIDQueue]="getUIDQueueForModule(kioskDashModule.boxTitle)"
        [theRecord]="kioskPaneHandle.singlePaneData"
        [kioskSvc]="kioskSvc"
        [vehicleTypes]="vehicleTypes"
        [sbSvcProvider]="sbSvcProvider"
        [appGlobals]="appGlobals"
        [customers]="activeCustomers"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [sites]="sites"
        [vehicleToAddToAcc]="vehicleToAddToContractAcc"
        (closePaneEmitter)="closePane(kioskDashModule.boxTitle)"
        [timeZoneOffset]="kioskDashModule.timeZoneOffset"
        (recordHistoryRequestEmitter)="appComponent.handleRecordHistoryRequest($event)"
      ></lib-kiosk-account-pane>
    </div>

    <div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="vehiclePaneHandle.isPaneOpen" [style.color]="vehiclePaneHandle.accentColor" style="width: 80%; height: auto; padding: 0;">
      <lib-vehicle-pane #vehiclePane
        [boxMainColor]="vehicleDashModule.boxMainColor"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [isAdmin]="isAdmin"
        [addMode]="vehiclePaneHandle.addMode"
        [editMode]="vehiclePaneHandle.editMode"
        [rollOffMode]="vehiclePaneHandle.specialMode"
        [recordUIDQueue]="getUIDQueueForModule(vehicleDashModule.boxTitle)"
        [theRecord]="vehiclePaneHandle.singlePaneData"
        [vehicleSvc]="vehicleSvc"
        [kioskSvc]="kioskSvc"
        [vehicleTypeSvc]="vehicleTypeSvc"
        [sbSvcProvider]="sbSvcProvider"
        [appGlobals]="appGlobals"
        (closePaneEmitter)="closePane(vehicleDashModule.boxTitle)"
        (recordHistoryRequestEmitter)="appComponent.handleRecordHistoryRequest($event)"
        (createNewContractAccountWithVehicleEmitter)="addVehicleToNewContractAccount($event)"
        (openContractAccountEmitter)="openContractAccount($event)"
      ></lib-vehicle-pane>
    </div>
    <div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards dashModule" *ngIf="paymentPaneHandle.isPaneOpen" [style.color]="paymentPaneHandle.accentColor" style="width: 90%; position: fixed; left: 10%; top: 2.5%; z-index: 204; height: auto; max-height: 95%; overflow-y: scroll;">
      <lib-payment-pane #paymentPane
        [forteScriptURL]="forteScriptURL"
        [boxMainColor]="paymentDashModule.boxMainColor"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [isAdmin]="isAdmin"
        [addMode]="paymentPaneHandle.addMode"
        [editMode]="paymentPaneHandle.editMode"
        [prepayMode]="prepayMode"
        [recordUIDQueue]="getUIDQueueForModule(paymentDashModule.boxTitle)"
        [theRecord]="paymentPaneHandle.singlePaneData"
        [paymentSvc]="paymentSvc"
        [payPendSvc]="payPendSvc"
        [forteSvc]="forteSvc"
        [invoiceSvc]="invoiceSvc"
        [webSocketSvc]="webSocketSvc"
        [sbSvcProvider]="sbSvcProvider"
        [appGlobals]="appGlobals"
        [errorSendingPayment]="errorSendingPayment"
        (closePaneEmitter)="closePane(paymentDashModule.boxTitle)"
        (requestRecordHistoryEmitter)="appComponent.handleRecordHistoryRequest($event)"
      ></lib-payment-pane>
    </div>
    <div class="dashModule" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" *ngIf="scaleTicketPaneHandle.isPaneOpen" [style.border-color]="sthDashModule.boxMainColor"
      style="width: 95%; position: fixed; left: 2.5%; top:2.5%; z-index: 204; height: auto; max-height: 95%; color: #000; overflow-y: scroll;">
      <lib-scaleticket-pane #scaleTicketPane
        [theRecord]="scaleTicketPaneHandle.singlePaneData"
        [iconClass]="sthDashModule.boxMainIconClass"
        [iconColor]="sthDashModule.boxMainColor"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [timeZoneOffset]="sthDashModule.timeZoneOffset"
        [recordUIDQueue]="getUIDQueueForModule(sthDashModule.boxTitle)"
        [grids]="grids"
        [matSubCats]="matSubCats"
        [vehicles]="vehicles"
        [vehicleTypes]="vehicleTypes"
        [customers]="activeCustomers"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [sites]="sites"
        [sthSvc]="sthSvc"
        [gridSvc]="gridSvc"
        [stdSvc]="stdSvc"
        [fileSvc]="fileSvc"
        [rateSvc]="rateSvc"
        [vehicleSvc]="vehicleSvc"
        [scaleLinkSvc]="scaleLinkSvc"
        [jobSvc]="jobDashSvc"
        [invoiceSvc]="invoiceSvc"
        [sbSvcProvider]="sbSvcProvider"
        [webSocketSvc]="webSocketSvc"
        [paymentSvc]="paymentSvc"
        [payPendSvc]="payPendSvc"
        [appGlobals]="appGlobals"
        [manifestLengthOverride]="manifestLengthOverride"
        [startEdit]="ticketEdit"
        [emailSvc]="contactEmailSvc"
        [voucherSvc]="voucherSvc"
        [signatureSvc]="signatureSvc"
        [overlaySvc]="overlaySvc"
        [modalSvc]="modalSvc"
        (zeroTicketEmitter)="handlePaymentWizard($event,true)"
        (openPaymentEmitter)="openPaymentFromScaleTicket($event)"
        (closePaneEmitter)="closePane(sthDashModule.boxTitle)"
        (recordHistoryRequestEmitter)="appComponent.handleRecordHistoryRequest($event)"
      ></lib-scaleticket-pane>
    </div>
    <div class="dashModule" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" *ngIf="jobPaneHandle.isPaneOpen" [style.border-color]="jobDashModule.boxMainColor"
      style="color: #333; width: 80%; position: fixed; left: 10%; top: 2.5%; z-index: 204; height: auto; max-height: 95%; overflow-y: scroll;">
      <lib-job-pane  #jobPane
        [iconClass]="jobDashModule.boxMainIconClass"
        [iconColor]="jobDashModule.boxMainColor"
        [theRecord]="jobPaneHandle.singlePaneData"
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [recordUIDQueue]="getUIDQueueForModule(jobDashModule.boxTitle)"
        [customers]="activeCustomers"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [sites]="sites"
        [jobSvc]="jobDashSvc"
        [rateSvc]="rateSvc"
        [webSocketSvc]="webSocketSvc"
        [sbSvcProvider]="sbSvcProvider"
        [appGlobals]="appGlobals"
        [timeZoneOffset]="jobDashModule.timeZoneOffset"
        (closePaneEmitter)="closePane(jobDashModule.boxTitle)"
        (requestRecordHistoryEmitter)="appComponent.handleRecordHistoryRequest($event)"
      ></lib-job-pane>
    </div>
    <div class="dashModule" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" *ngIf="scaleticketPreScreenOpen" [style.border-color]="sthDashModule.boxMainColor"
      style="color: #333; width: 80%; position: fixed; left: 10%; top: 2.5%; z-index: 204; height: auto; max-height: 95%; overflow-y: auto;">
      <lib-scaleticket-prescreen
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [iconClass]="sthDashModule.boxMainIconClass"
        [iconColor]="sthDashModule.boxMainColor"
        [jobIconClass]="jobDashModule.boxMainIconClass"
        [vehicleTypes]="vehicleTypes"
        [customers]="activeCustomers"
        [jobCodes]="jobCodes"
        [jobCategories]="jobCategories"
        [openWithVehicle]="preScreenOpenWithVehicle"
        [sites]="sites"
        [manifestLengthOverride]="manifestLengthOverride"
        [vehicleSvc]="vehicleSvc"
        [kioskSvc]="kioskSvc"
        [rateSvc]="rateSvc"
        [jobSvc]="jobDashSvc"
        [sbSvcProvider]="sbSvcProvider"
        [appGlobals]="appGlobals"
        [voucherSvc]="voucherSvc"
        [overlaySvc]="overlaySvc"
        [modalSvc]="modalSvc"
        [prescreenMemo]="prescreenMemo"
        (prescreenCompletedEmitter)="handleScaleTicketPreScreen($event)"
        (prescreenCancelledEmitter)="handleScaleTicketPreScreen($event)">
      </lib-scaleticket-prescreen>
    </div>

    <div class="dashModule" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" *ngIf="reportPreScreenOpen" [style.border-color]="invoiceDashModule.boxMainColor"
      style="color: #333; width: 80%; position: fixed; left: 10%; top: 2.5%; z-index: 204; height: auto; max-height: 95%; overflow-y: auto;">
      <lib-invoice-report-prescreen
        [darkMode]="appGlobals.getStoredDarkModeSetting()"
        [glassMode]="appGlobals.getStoredGlassModeSetting()"
        [iconClass]="invoiceDashModule.boxMainIconClass"
        [iconColor]="invoiceDashModule.boxMainColor"
        [contactIconClass]="jobDashModule.boxMainIconClass"
        [customers]="activeCustomers"
        [sbSvcProvider]="sbSvcProvider"
        [appGlobals]="appGlobals"
        [isCustStatement]="isCustStatement"
        [invoiceSvc]="invoiceSvc"
        (prescreenCompletedEmitter)="handleReportPreScreen($event)"
        (prescreenCancelledEmitter)="handleReportPreScreen($event)">
      </lib-invoice-report-prescreen>
    </div>
  </div>

  <lib-contact-wizard-handler *ngIf="createContactWizOpen"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [debounceTime]="appGlobals.dropdownTypeDebounceTime"
    [wizardColor]="contactDashModule.boxMainColor"
    [wizardIcon]="contactDashModule.boxMainIconClass"
    [dashTitle]="contactDashModule.boxTitle"
    [userMode]="createContactUserMode"
    [contactToPromote]="promoteContact"
    [contactTypes]="preLoadContactTypes"
    [jobCategories]="jobCategories"
    [jobCodes]="jobCodes"
    [userGroups]="userGroups"
    [contactSvc]="contactDashSvc"
    [jobSvc]="jobDashSvc"
    [userSvc]="userSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobalsSvc]="appGlobals"
    [terms]="terms"
    (closeWizard)="closeContactWizard(undefined)"
    (openRecord)="closeContactWizard($event)"
    (openNewRecord)="closeContactWizard($event)">
  </lib-contact-wizard-handler>

  <ng-template #contactDashTemplate1Override>
    <button class="btn btn-outline-secondary" (click)="openVoucherAccountsPane();" *ngIf="vouchersEnabled"><i class="fal fa-fw fa-ticket-alt"></i></button>
  </ng-template>

  <div style="position: fixed; top:1%; left: 1%; width:98%; min-height: 98%; height: auto; max-height: 98%; overflow-y: scroll; overflow-x: auto; z-index:204; color: #000;" [style.border-color]="contactDashModule.boxMainColor" *ngIf="voucherPaneOpen" [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" [ngStyle]="{'background-color': appGlobals.getStoredDarkModeSetting() ? '#333' : '#ddd'}">
    <lib-voucher-dash
      [dataService]="voucherSvc" [overlaySvc]="overlaySvc" [modalSvc]="modalSvc"
      [editWithContact]="voucherPaneEditWithContact" [editWithVoucher]="voucherPaneEditWithVoucher" [paneMode]="voucherPaneEditMode" [darkMode]="appGlobals.getStoredDarkModeSetting()"
      (closedEmitter)="closeVoucherAccountsPane()"></lib-voucher-dash>
  </div>

  <div class="dashModule" style="position: fixed; top:2.5%; left:0.5%; width:99%; min-height: 75%; height: auto; max-height: 95%; overflow-y: scroll; overflow-x: auto; z-index:204; color: #000;" [style.border-color]="contactDashModule.boxMainColor" *ngIf="viewRateSchedules">
    <lib-rate-schedule [rateScheduleHeader]="rateHeader"
      [accentColor]="contactDashModule.boxMainColor"
      [materialsAndServices]="materialsAndServices"
      [rateSvc]="rateSvc"
      [sbSvcProvider]="sbSvcProvider"
      [appGlobals]="appGlobals"
      (rateScheduleCopyEvent)="launchCopyRateScheduleWizard($event)"
      (rateScheduleClose)="closeRateSchedules()"
      (rateScheduleUpdated)="updateClientRS($event)"></lib-rate-schedule>
  </div>

  <div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="copyRateWizOpen" [style.color]="rateHeader.contactContactUID !== 0 ? contactPaneHandle.accentColor : jobPaneHandle.accentColor" style="width: 80%; height: auto; padding: 0; z-index: 206;">
    <lib-copy-rate-wizard #copyWizard *ngIf="copyRateWizOpen"
      [mainColor]="rateHeader.contactContactUID !== 0 ? contactPaneHandle.accentColor : jobPaneHandle.accentColor"
      [darkMode]="appGlobals.getStoredDarkModeSetting()"
      [glassMode]="appGlobals.getStoredGlassModeSetting()"
      [rateSchedule]="rateHeader"
      [customers]="activeCustomers"
      [jobCodes]="jobCodes"
      [jobCategories]="jobCategories"
      [sites]="sites"
      [materialsAndServices]="materialsAndServices"
      [rateSvc]="rateSvc"
      [jobSvc]="jobDashSvc"
      [customerSvc]="contactDashSvc"
      [sbSvcProvider]="sbSvcProvider"
      [appGlobals]="appGlobals"
      (wizardCompletedEmitter)="handleCopyRateScheduleWizard($event)"
      (wizardCancelledEmitter)="cancelCopyRateScheduleWizard($event)">
        <i [ngClass]="'fal fa-money-check-alt'" style="font-size: 2rem;" [style.color]="rateHeader.contactContactUID !== 0 ? contactPaneHandle.accentColor : jobPaneHandle.accentColor"></i>
        <strong [style.color]="rateHeader.contactContactUID !== 0 ? contactPaneHandle.accentColor : jobPaneHandle.accentColor">Copy Rate Schedule{{ copyWizard.copyRateWizard?.currentStep > 0 ? (copyWizard.toCustomer ? " to Customer" : " to Job") : ""}}</strong>
    </lib-copy-rate-wizard>
  </div>

  <!-- Contact Pane custom tab -->
  <ng-template #pawneeCustomPane let-theRecord let-editMode="editMode">
    <div id="pawneeCustomTemplate" style="margin-bottom: 10em;">
      <div *ngIf="checkIfContactIsCustomer(theRecord); else notCustomer">
        <div class="form-row d-flex" style="background-color: #eee; padding-top: 0.25em; padding-bottom: 0.25em;">
          <h5  class="label sectionLabel Starbase-Title-Font" style="width: auto; line-height: normal;" [style.color]="contactDashModule.boxMainColor">
            <i class="fal fa-lg fa-clipboard me-1"></i>
            Details
          </h5>
          <button *ngIf="theRecord.uid > 0 && (currentUser.hasPermissions('invoicewritevoid') || isAdmin())" style="margin-left: 16em; height: 2em;" (click)="viewCustomerRateSchedule(theRecord)" [matTooltip]="theRecord.rateScheduleHeader ? 'View Rate Schedule' : 'Add Rate Schedule'" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false" class="btn" [ngClass]="{'btn-outline-success': theRecord.rateScheduleHeader, 'btn-outline-warning': !theRecord.rateScheduleHeader}">
            <i class="far fa-money-check-alt fa-lg"></i>
          </button>
        </div>
        <div *ngIf="this.appGlobals.site?.accountingType == 2" class="form-row" style="margin-left: 3em;">
          <label for="custAccNo">
            Customer Account #
          </label>
          <span class="ms-1" *ngIf="!editMode; else editAccNo">
            <label style="margin-left: 2rem;">
              {{ theRecord.customerAccountNo }}
            </label>
          </span>
          <ng-template #editAccNo>
            <input #custAccNo type="number" class="input account" [(ngModel)]="theRecord.customerAccountNo">
          </ng-template>
        </div>

        <div class="form-row mt-2" style="margin-left: 3em;">
          <label for="coiRequired">
            Certificate of Insurance Required?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editCOI">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.certofInsuranceRequired, 'text-danger': !theRecord.certofInsuranceRequired}">
              {{ theRecord.certofInsuranceRequired ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editCOI>
            <label class="switch" style="margin-left: 2rem;">
              <input name="coiRequired" type="checkbox" [(ngModel)]="theRecord.certofInsuranceRequired">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;" *ngIf="theRecord.certofInsuranceRequired">
          <label style="text-align: left;" for="coiExpiration">
            Certificate of Insurance Expiration
          </label>
          <span class="ms-1" *ngIf="!editMode; else editCOIExp">
            <label style="margin-left: 2rem;">{{ theRecord.certOfInsuranceExpDate | date:'MM/dd/yyyy':'MST' }}</label>
          </span>
          <ng-template #editCOIExp>
            <div class="input-group" style="padding-bottom: 0.75rem;">
              <input #coiExpiration name="coiExpiration" bsDatepicker [ngModel]="theRecord.certOfInsuranceExpDate | date:'MM/dd/yyyy'" (ngModelChange)="theRecord.certOfInsuranceExpDate=$event;">
              <div class="input-group-append" (click)="coiExpiration.click()">
                <span class="input-group-text" id="cal-addon"><i class="fas fa-calendar-week fa-lg"></i></span>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;">
          <label for="mattestRequired">
            Materials Test Required?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editMatTest">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.materialsTestRequired, 'text-danger': !theRecord.materialsTestRequired}">
              {{ theRecord.materialsTestRequired ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editMatTest>
            <label class="switch" style="margin-left: 2rem;">
              <input name="mattestRequired" type="checkbox" [(ngModel)]="theRecord.materialsTestRequired">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;" *ngIf="theRecord.materialsTestRequired">
          <label style="text-align: left;" for="mattestExpiration">
            Materials Test Expiration
          </label>
          <span class="ms-1" *ngIf="!editMode; else editMatTestExp">
            <label style="margin-left: 2rem;">{{ theRecord.materialsTestExpDate | date:'MM/dd/yyyy':'MST' }}</label>
          </span>
          <ng-template #editMatTestExp>
            <div class="input-group" style="padding-bottom: 0.75rem;">
              <input #mattestExpiration name="mattestExpiration" bsDatepicker [ngModel]="theRecord.materialsTestExpDate | date:'MM/dd/yyyy'" (ngModelChange)="theRecord.materialsTestExpDate=$event">
              <div class="input-group-append" (click)="mattestExpiration.click()">
                <span class="input-group-text" id="cal-addon"><i class="fas fa-calendar-week fa-lg"></i></span>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;">
          <label style="text-align: left;" for="saExecuted">
            SA Executed Date
          </label>
          <span class="ms-1" *ngIf="!editMode; else editSAExecuted">
            <label style="margin-left: 2rem;">{{ theRecord.saExecutedDate | date:'MM/dd/yyyy':'MST' }}</label>
          </span>
          <ng-template #editSAExecuted>
            <div class="input-group" style="padding-bottom: 0.75rem;">
              <input #saExecuted name="saExecuted" bsDatepicker [ngModel]="theRecord.saExecutedDate | date:'MM/dd/yyyy'" (ngModelChange)="theRecord.saExecutedDate=$event">
              <div class="input-group-append" (click)="saExecuted.click()">
                <span class="input-group-text" id="cal-addon"><i class="fas fa-calendar-week fa-lg"></i></span>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;">
          <label for="showRates" [matTooltip]="'Only applicable if Customer is ON ACCOUNT otherwise rates are always shown.'">
            Show Rates on Scale Tickets during Invoicing?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editShowRates">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.showTicketRatesOnInvoice, 'text-danger': !theRecord.showTicketRatesOnInvoice }">
              {{ theRecord.showTicketRatesOnInvoice ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editShowRates>
            <label class="switch" style="margin-left: 2rem;">
              <input name="showRates" type="checkbox" [(ngModel)]="theRecord.showTicketRatesOnInvoice">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div *ngIf="theRecord.customerPaymentMethod == 1" class="form-row" style="margin-left: 3em;">
          <label for="showTicketRates" [matTooltip]="'Only applicable if Customer is ON ACCOUNT otherwise rates are always shown.'"> <!-- [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false"-->
            Show Rates on Scale Tickets?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editShowTicketRates">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.showRatesOnTicket || theRecord.customerPaymentMethod != 1, 'text-danger': !theRecord.showRatesOnTicket && theRecord.customerPaymentMethod == 1 }">
              {{ theRecord.showRatesOnTicket || theRecord.customerPaymentMethod != 1 ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editShowTicketRates>
            <label class="switch" style="margin-left: 2rem;">
              <input name="showRates" type="checkbox" [(ngModel)]="theRecord.showRatesOnTicket">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;">
          <label style="margin-top: .5rem;" for="customerPaymentMethod">
            Customer Payment Method
          </label>
          <span class="ms-1" *ngIf="!editMode; else editCPM">
            <label style="margin-left: 2rem; margin-top: 0.5rem;"> {{ theRecord.customerPaymentMethod == 4 ? 'Cash One Time No Name' : theRecord.customerPaymentMethod == 3 ? 'Cash One Time' : theRecord.customerPaymentMethod == 2 ? 'Cash' : 'On Account' }}</label>
          </span>
          <ng-template #editCPM>
            <select style="margin-left: 2rem !important; margin-top: 0.25rem; width: 200px;" name="customerPaymentMethod" [(ngModel)]="theRecord.customerPaymentMethod" type="number" class="form-control-sm editable ms-1 me-2">
              <option value="1" title="Marks customer as ON ACCOUNT and hides dollar values on Scale Tickets">On Account</option>
              <option value="2" title="Marks Customer as Cash Customer function like ON ACCOUNT except dollar values are shown on Scale Tickets">Cash</option>
              <option value="3" title="Marks Customer as Cash One Time Customer Functions like Cash accept information about Customer will be collected when creating each Scale Ticket">Cash One Time</option>
              <option value="4" title="Marks Customer as Cash One Time, but doesn\'t require the collection of information when creating a Scale ticket">Cash One Time No Name</option>
            </select>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;">
          <label style="margin-top: .5rem;" for="customerNotesForTicket" [matTooltip]="'This Special text is shown when a Scale Ticket for this Customer is displayed.'">
            Customer Specific Notification
          </label>
          <span style="width: 100%; white-space: pre;" *ngIf="!editMode; else editNFT">
            {{ theRecord.notesForTicket }}
          </span>
          <ng-template #editNFT>
            <textarea [(ngModel)]="theRecord.notesForTicket" class="form-control editable ng-pristine ng-star-inserted ng-touched"
              style="width: 100%; resize: none; height: 100px; margin-bottom: 2rem;">
            </textarea>
          </ng-template>
        </div>

        <div *ngIf="appGlobals.site.accountingType === 1" class="form-row" style="margin-left: 3em;">
          <label for="showTicketRates" [matTooltip]="'Sumarize Payments and Invoices on Accounting Import?'">
            Summarize Customer Data on Accounting Import?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editSummarize">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.summarizeAccountingImport, 'text-danger': !theRecord.summarizeAccountingImport }">
              {{ theRecord.summarizeAccountingImport ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editSummarize>
            <label class="switch" style="margin-left: 2rem;">
              <input name="showRates" type="checkbox" [(ngModel)]="theRecord.summarizeAccountingImport">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;">
          <label for="showTicketRates" [matTooltip]="'Exempt this Customer from Taxes?'">
            Tax Exempt?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editTaxExempt">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.taxExempt, 'text-danger': !theRecord.taxExempt }">
              {{ theRecord.taxExempt ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editTaxExempt>
            <label class="switch" style="margin-left: 2rem;">
              <input name="showRates" type="checkbox" [(ngModel)]="theRecord.taxExempt">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div class="form-row" style="margin-left: 3em;" *ngIf="appGlobals.site.enableMobileSignatureCollection">
          <label for="requireSignatureOnTickets" [matTooltip]="'Require this customer to provide driver signatures on all scale tickets?'">
            Require Signature on Tickets
          </label>
          <span class="ms-1" *ngIf="!editMode; else editRequireSignatureOnTickets">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.requireSignatureOnTickets, 'text-danger': !theRecord.requireSignatureOnTickets }">
              {{ theRecord.requireSignatureOnTickets ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editRequireSignatureOnTickets>
            <label class="switch" style="margin-left: 2rem;">
              <input name="requireSignatureOnTickets" type="checkbox" [(ngModel)]="theRecord.requireSignatureOnTickets">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <hr *ngIf="theRecord.accountCredit != 0">
        <div *ngIf="theRecord.accountCredit != 0">
          <div class="form-row" style="margin-left: 3em; font-weight: bold;">
            <label style="text-align: left;">
              Available Account Credit
            </label>
            <span class="ms-1">
              <label style="margin-left: 2rem;">$ {{ theRecord.accountCredit | number: '1.2-2' }}</label>
            </span>
          </div>
        </div>

        <hr *ngIf="(theRecord.customerPaymentMethod == 1 || theRecord.customerPaymentMethod == 2) && appGlobals.site != null ? appGlobals.site.financeChargeOn : ''">
        <div *ngIf="(theRecord.customerPaymentMethod == 1 || theRecord.customerPaymentMethod == 2) && appGlobals.site != null ? appGlobals.site.financeChargeOn : ''" class="form-row" style="margin-left: 3em;">
          <label [matTooltip]="'Only applicable if Customer is ON ACCOUNT otherwise rates are always shown.'">
            Apply Finance Charges?
          </label>
          <span class="ms-1" *ngIf="!editMode; else editApplyFinance">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.applyFinanceCharge || theRecord.customerPaymentMethod != 1, 'text-danger': !theRecord.applyFinanceCharge && theRecord.customerPaymentMethod == 1 }">
              {{ theRecord.applyFinanceCharge || theRecord.customerPaymentMethod != 1 ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editApplyFinance>
            <label class="switch" style="margin-left: 2rem;">
              <input name="showRates" type="checkbox" [(ngModel)]="theRecord.applyFinanceCharge">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div *ngIf="(theRecord.customerPaymentMethod == 1 || theRecord.customerPaymentMethod == 2) && (appGlobals.site != null ? appGlobals.site.financeChargeOn : false) && theRecord.applyFinanceCharge" class="form-row" style="margin-left: 3em;">
          <label [matTooltip]="'Only applicable if Customer is ON ACCOUNT otherwise rates are always shown.'">
            Use Site Default Term of <b>{{appGlobals.site.siteTerm.name}}</b>
          </label>
          <span class="ms-1" *ngIf="!editMode; else editSiteTerm">
            <label style="margin-left: 2rem;" [ngClass]="{'text-success': theRecord.useSiteTerm || theRecord.customerPaymentMethod != 1, 'text-danger': !theRecord.useSiteTerm && theRecord.customerPaymentMethod == 1 }">
              {{ theRecord.useSiteTerm || theRecord.customerPaymentMethod != 1 ? 'Yes' : 'No' }}
            </label>
          </span>
          <ng-template #editSiteTerm>
            <label class="switch" style="margin-left: 2rem;">
              <input name="showRates" type="checkbox" [(ngModel)]="theRecord.useSiteTerm">
              <span class="slider round"></span>
            </label>
          </ng-template>
        </div>

        <div *ngIf="(theRecord.customerPaymentMethod == 1 || theRecord.customerPaymentMethod == 2) && theRecord.applyFinanceCharge && (appGlobals.site != null ? appGlobals.site.financeChargeOn : false) && !theRecord.useSiteTerm"  class="form-row" style="margin-left: 3em;">
          <label style="margin-right: .5rem; margin-top: .5em; margin-bottom: 0;" for="customerNotesForTicket" [matTooltip]="'This is the terms that will be set on all invoices for this customer'">
            Terms:
          </label>
          <span class="ms-1" *ngIf="!editMode; else editTRM">
            <label style="margin-left: 2rem; margin-top: .5em; margin-bottom: 0;">
              {{ theRecord.term != null ? theRecord.term.name : '' }}
            </label>
          </span>
          <ng-template #editTRM>
            <div class="input-group" style="margin-left: 2rem !important; margin-top: 0.25rem; width: 200px; ">
              <select [(ngModel)]="theRecord.termsUID" name="term" type="number" class="form-control editable ms-1 me-2">
                <option [value]="0" (click)="updateCustomerTerm(theRecord , 0)">No Term</option>
                <option *ngFor="let term of activeTerms" [value]="term.uid" (click)="updateCustomerTerm(theRecord , term.uid)">{{term.name}}</option>
              </select>
            </div>
            <!--
            <mat-form-field *ngIf="editMode" style="height: 3em; margin-top: -1rem;">
              <mat-label>Term</mat-label>
              <mat-select  [(ngModel)]="theRecord.termsUID">
                <mat-select-trigger>{{ theRecord.term ? theRecord.term.name : '' }}</mat-select-trigger>
                <mat-option class="multiline-mat-option" value="0" (click)="updateCustomerTerm(theRecord , 0)">
                  <div>
                    Reset
                  </div>
                </mat-option>
                <mat-option class="multiline-mat-option" *ngFor="let term of terms" [value]="term.uid" (click)="updateCustomerTerm(theRecord , term.uid)">
                  <div >{{term.name}}</div>
                </mat-option>
              </mat-select>
            </mat-form-field>
            -->
          </ng-template>
        </div>
        <br>

        <div *ngIf="appGlobals.site.paymentsActive" class="form-row" style="margin-left: 3em;">
          <label style="margin-right: .5rem; margin-top: .5em; margin-bottom: 0;" [matTooltip]="'Limit value is only for this customer. On Scale Ticket Submit a notification will show when this customer is approaching or exceeding this debt limit.'">
            Outstanding Customer Debt Limit
          </label>
          <span class="ms-1" *ngIf="!editMode; else editMax">
            <label style="margin-left: 2rem; margin-top: .5em; margin-bottom: 0;">
              ${{ theRecord.ticketCreditMax }}
            </label>
          </span>
          <ng-template #editMax>
            <label style="margin-top: .5em; margin-bottom: 0;"><b>$</b></label>
            <input *ngIf="editMode" type="text" class="form-control editable" style="width:150px;" (change)="updateInputFields(theRecord)" libCommaInput [decimalPlaces]="2" placeholder="0.00" [(ngModel)]="contactDebtLimitInput">
          </ng-template>
        </div>
      </div>

      <ng-template #notCustomer>
        <div *ngIf="(currentUser.hasPermissions('invoicewritevoid') || isAdmin()); else unavailable">
          <div class="form-row mt-1" style="background-color: #eee; padding: 0.25em 0;">
            <h5 class="label sectionLabel Starbase-Title-Font" style="width: auto; line-height: normal; color: gray;" [style.color]="contactDashModule.boxMainColor">
              <i class="fal fa-lg fa-clipboard me-1"></i>
              Details
            </h5>
          </div>
          <div class="ms-3">
            <p class="text-muted">
              <i class="fal fa-do-not-enter me-1"></i>
              This tab is unavailable <br>
              <span class="ps-4">because this contact is not a <strong>Customer</strong>.</span>
            </p>
            <p class="small text-muted">
              <i class="fal fa-info-circle text-info me-1"></i>
              You can add the <strong>Customer</strong> contact type to this record <br>
               <span class="ps-4">from the <i class="fal fa-id-card"></i><em>Demographics</em> tab.</span>
            </p>
          </div>
        </div>
      </ng-template>

      <ng-template #unavailable>
        <div class="form-row mt-1" style="background-color: #eee; padding: 0.25em 0;">
          <h5 class="label sectionLabel Starbase-Title-Font" style="width: auto; line-height: normal; color: gray;" [style.color]="contactDashModule.boxMainColor">
            <i class="fal fa-lg fa-clipboard me-1"></i>
            Details
          </h5>
        </div>
        <div class="ms-3">
          <p class="text-muted">
            <i class="fal fa-do-not-enter me-1"></i>
            This tab is unavailable.
          </p>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <!-- Contact Pane custom tab -- Vouchers -->
  <ng-template #contactVoucherTab let-theRecord let-editMode="editMode">
    <div id="contactVoucherTab" style="margin-bottom: 10em;">
      <div class="form-row d-flex" style="background-color: #eee; padding-top: 0.25em; padding-bottom: 0.25em;">
        <h5 class="label sectionLabel Starbase-Title-Font" style="width: auto; line-height: normal;" [style.color]="contactDashModule.boxMainColor">
          <i class="fal fa-lg fa-ticket-alt me-1"></i>
          Manage Linked Vouchers
        </h5>
      </div>

      <div class="table-responsive mt-2">
        <table class="table table-sm table-hover align-middle mb-0" style="font-size: 0.75rem;">
          <thead class="table-light">
            <tr>
              <th scope="col" class="text-start" [matTooltip]="contactVoucherIDTooltip()">{{ appGlobals.site.voucherIdentificationType === 0 ? "DL #" : "ID"}}</th>
              <th scope="col">Primary User</th>
              <th scope="col" class="text-center" matTooltip="Remaining vouchers" *ngIf="appGlobals.site.voucherSystem !== 2">Remaining</th>
              <th scope="col" class="text-center" matTooltip="Authorized Users">AU</th>
              <th scope="col" class="text-center" matTooltip="Account Active">Active</th>
              <th scope="col" class="text-end">Quick Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="theRecord?.vouchers != null ? theRecord?.vouchers.length === 0 : false">
              <td [attr.colspan]="appGlobals.site.voucherSystem == 2? 5 : 6" class="text-center text-muted py-3">
                <small>No linked vouchers</small>
              </td>
            </tr>

            <tr *ngFor="let v of theRecord.vouchers">
              <td><strong>{{ v.voucherID }}</strong></td>
              <td>{{ v.firstName }} {{ v.lastName }}</td>
              <td class="text-center" *ngIf="appGlobals.site.voucherSystem !== 2">{{ v.vouchersRemaining }}</td>
              <td class="text-center" [matTooltip]="contactVoucherAUTooltip(v)">{{ v.authorizedUsers?.length || 0 }}</td>
              <td class="text-center">{{ v.voucherActive ? "✓": "" }}</td>
              <td class="text-end">
                <div class="btn-group btn-group-sm" *ngIf="v.voucherActive">
                  <button type="button"  tabindex="2"
                          class="btn btn-outline-secondary"
                          matTooltip="Edit Voucher Account"
                          (click)="editVoucherAccount(theRecord, v, false)">
                    <i class="fas fa-pencil"></i>
                  </button>
                  <button type="button"
                          class="btn btn-outline-secondary"
                          matTooltip="Manage Authorized Users"
                          (click)="editVoucherAccount(theRecord, v, true)" tabindex="2">
                    <i class="fas fa-user-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="actions-no-vouchers mt-2 p-2">
          <button class="btn btn-sm btn-outline-dark" (click)="createNewVoucherRecordWithContact(theRecord);"  tabindex="2">Create New Voucher</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #defaultQuickActions let-contact="contact">
    <button class="commType dropdown-item" (click)="contactDashModule.toggleFavorite(contact);">
      <span *ngIf="contact.favorite">Unfavorite</span>
      <span *ngIf="!contact.favorite">Set as favorite</span>
      <i class="fal fa-fw fa-star fa-lg"></i>
    </button>
    <button class="commType dropdown-item" (click)="openRecordType(contact)">
      View Contact
      <i class="fal fa-fw fa-arrow-circle-right fa-lg" (click)="openRecordType(contact)"></i>
    </button>
    <button *ngIf="contact?.userAccountUID && this.isAdmin()" class="commType dropdown-item" (click)="contactDashModule.openUser(contact.userAccountUID)">
      Manage User
      <i class="fal fa-fw fa-user-cog fa-lg"></i>
    </button>
    <button *ngIf="checkIfContactIsCustomer(contact) && (currentUser.hasPermissions('invoiceread') || isAdmin())" (click)="viewCustomerRateSchedule(contact)" class="commType dropdown-item">
      {{ contact.rateScheduleHeader ? 'View Rate Schedule' : 'Add Rate Schedule' }}
      <i class="fal fa-money-check-alt fa-lg"></i>
    </button>
    <div>
      <button *ngIf="contact?.preferredEmail().getCommAddress() !== ''" class="commType commType-email dropdown-item"
        (click)="contactDashModule.sendEmailToContact([contact])">
        Send Email
        <i class="fal fa-fw fa-envelope fa-lg"></i>
      </button>
      <button class="commType commType-phone dropdown-item" *ngIf="contact?.preferredPhone().getCommAddress() !== ''"
        (click)="contactDashModule.sendTextToContact(contact.preferredPhone().getCommAddress())">
        Send SMS
        <i class="fal fa-fw fa-mobile fa-lg"></i>
      </button>
    </div>
    <button *ngIf="(appGlobals.site != null ? appGlobals.site.paymentsActive : '') && checkIfContactIsCustomer(contact)  && (this.isAdmin() || currentUser.hasPermissions('invoiceread'))"  class="commType dropdown-item" (click)="customerStatement(contact,null)">
      Customer Statement
      <i class="fal fa-id-card"></i>
    </button>
    <!-- <button *ngIf="(appGlobals.site != null ? appGlobals.site.paymentsActive : '') && checkIfContactIsCustomer(contact)  && this.isAdmin() && false"  class="commType dropdown-item" (click)="oneMonthCustomerStatement(contact)">
      Customer Statement for {{getMonthText(date.getMonth())}}
      <i class="fal fa-id-card"></i>
    </button>
    <button *ngIf="(appGlobals.site != null ? appGlobals.site.paymentsActive : '') && checkIfContactIsCustomer(contact)  && this.isAdmin() && false"  class="commType dropdown-item" (click)="customCustomerStatement(contact)">
      Custom Customer Statement
      <i class="fal fa-id-card"></i>
    </button> -->
    <button *ngIf="(appGlobals.site != null ? appGlobals.site.paymentsActive : '') && checkIfContactIsCustomer(contact)  && (this.isAdmin() || currentUser.hasPermissions('invoiceread'))"  class="commType dropdown-item" (click)="customerHistory(contact)">
      Customer History
      <i class="fal fa-id-card"></i>
    </button>
    <button *ngIf="(appGlobals.site != null ? appGlobals.site.paymentsActive : '') && checkIfContactIsCustomer(contact)  && (this.isAdmin() || currentUser.hasPermissions('invoiceread'))" class="commType dropdown-item" (click)="custInvoiceAgingDetail(contact)">
      Invoice Aging Detail
      <i class="fal fa-id-card"></i>
    </button>
    <button *ngIf="(appGlobals.site != null ? appGlobals.site.paymentsActive : '') && checkIfContactIsCustomer(contact)  && (this.isAdmin() || currentUser.hasPermissions('invoiceread'))" class="commType dropdown-item" (click)="openEmailCustStatement(contact)">
      Email Customer Statement
      <i class="fal fa-id-card"></i>
    </button>
  </ng-template>

  <div class="wizards"
      style="width: 55%; min-width: 550px; height: auto; padding-bottom: 3em; left: 50% !important; border: solid; text-align: center; display: flex; flex-direction: column; background: white;"
      *ngIf="customerStatementModalOpen">
      <div class="topPaneHolder">
        <div style="justify-content: center;">
          <h1 style="padding-top: 1em;"><i class="fal fa-file-invoice-dollar"></i>
            Customer Statement Report
          </h1>
        </div>
        <div style=" top: 10px; right: 10px; position: absolute;">
          <button [matTooltip]="'Close'" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false" (click)="closeCustomerStatement()" class="btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <div class="row" style="justify-content: center; margin: 0.25em;">
              <!--
        <div class="form-inline form-group">
          <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
            <label for="loadingToggle" class="btn btn-sm btn-light active">&nbsp;Single Customer Report&nbsp;
              <input type="radio" required name="loadingToggle" autocomplete="off" id="loadingToggle">
            </label>
          </div>
        </div>
      </div>
      <div>
        <span> <b>Select a Date Range</b></span>
        <div class="input-group" style="width: 25em; margin: auto; margin-bottom: 2em;">
          <input
            [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (filterDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
            placeholder="Date Range" id="dateRange" name="dateRange" #filterDateRange bsDaterangepicker
            [bsConfig]="bsConfig" (bsValueChange)="dateRangeChangeForInvoices($event)" class="form-control"
            aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">
          <div class="input-group-append" [matTooltipShowDelay]="tooltipDelay"
            matTooltip="Set a scale ticket date range filter"
            (click)="filterDateRange.click()">
            <span class="input-group-text" id="cal-addon"><i
                class="fas fa-calendar-week fa-lg"></i></span>
          </div>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button"
              (click)="filterDateFrom = null; filterDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>
          </div>
        </div>
        <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
          <div style="min-width: 750px; text-align: center;">
            <span style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</span>
          </div>
        </div>
      -->

        <div style="width: 90%; min-width: 500px; margin: auto; margin-bottom: 2em;">
          <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isDownloading">
            <div title="Please wait..." class="ball-pulse">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="width: 100%; justify-content: flex-end;">
        <button class="btn btn-success"
          type="button"
          (click)="showCustStatement()">
          <i class="fal fa-check"></i>
          Generate
        </button>
        <button class="btn btn-outline-warning" style="float: center;"
          type="button" (click)="closeCustomerStatement()">
          <i class="fal fa-times"></i>
          Close
        </button>
      </div>
    </div>

    <div class="wizards"
      style="width: 55%; min-width: 550px; height: auto; left: 50% !important; border: solid; text-align: center; display: flex; flex-direction: column; background: white; border-radius: 1em;"
      *ngIf="customerHistoryModalOpen">
      <div class="topPaneHolder">
        <div style="justify-content: center;">
          <h1 style="padding-top: 1em; color: initial;"><i class="fal fa-file-invoice-dollar"></i>
            Customer Statement Report
          </h1>
        </div>
        <div style=" top: 10px; right: 10px; position: absolute;">
          <button [matTooltip]="'Close'" (click)="closeCustomerHistory()" class="btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div style="padding: 1em;">
        <span> <b>Select a Date Range</b></span>
        <div class="input-group" style="width: 25em; margin: auto; margin-bottom: 2em;">
          <input
            [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy':appGlobals.timeZone) + ' - ' + (filterDateTo | date: 'MM/dd/yyyy':appGlobals.timeZone) : ''"
            placeholder="Date Range" id="dateRange" name="dateRange" #filterDateRange bsDaterangepicker
            [bsConfig]="bsConfig" (bsValueChange)="dateRangeChangeForInvoices($event)" class="form-control"
            aria-label="Scale Ticket Dash Date Range" aria-describedby="cal-addon"
            [matTooltipShowDelay]="tooltipDelay" matTooltip="Set a scale ticket date range filter">
          <div class="input-group-append" [matTooltipShowDelay]="tooltipDelay"
            matTooltip="Set a scale ticket date range filter"
            (click)="filterDateRange.click()">
            <span class="input-group-text btn btn-outline-secondary" id="cal-addon"><i
                class="fas fa-calendar-week fa-lg"></i></span>
          </div>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary"
              [matTooltipShowDelay]="tooltipDelay" matTooltip="Clear date range" type="button"
              (click)="filterDateFrom = null; filterDateTo = null;">
              <i class="fad fa-calendar fa-lg"></i>
            </button>
          </div>
        </div>
        <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
          <div style="min-width: 750px; text-align: center;">
            <span style="color: red;">WARNING: This report is better suited to shorter date ranges. Longer date ranges may cause this report to fail.</span>
          </div>
        </div>


        <div class="row" style="justify-content: center; margin: 0.25em;">
          <div style="width: 90%; min-width: 500px; margin: auto; margin-bottom: 2em;">
            <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isDownloading">
              <div title="Please wait..." class="ball-pulse">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%; justify-content: flex-end;">
          <div class="column" style="width: 50%; padding: 0; margin: 0;">
            <button class="btn btn-outline-warning" style="width: 100%;"
              type="button" (click)="closeCustomerHistory()">
              <i class="fal fa-times"></i>
              Close
            </button>
          </div>
          <div class="column" style="width: 50%; padding: 0; margin: 0;">
            <button class="btn btn-success" style="width: 100%;"
              type="button"
              (click)="showCustomerHistory()">
              <i class="fal fa-check"></i>
              Generate
            </button>
          </div>
        </div>
      </div>
    </div>

  <ng-template #dashOptionsModal>
    <h5>Drag to change dash module order</h5>
    <div [nxtSortablejs]="pawneeDashConfs" [config]="dashResortOptions">
      <div *ngFor="let d of pawneeDashConfs; let i = index">
        <div class="dashModuleMock" [style.border-color]="d.boxMainColor">
          <div class="row dashTitleMock Starbase-Title-Font" [style.color]="d.boxMainColor">
            <i [class]="'fa-fw fal ' + d.boxMainIconClass" style="margin: 10px; margin-bottom: 0px; width: auto !important;" ></i>
            {{ d.boxTitle }}
          </div>
        </div>
        <i class="fal fa-lg fa-grip-horizontal ms-2 grabHandle" matTooltip="Drag to reorder the dash modules" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false" libHoverColor="black"></i>
      </div>
    </div>
    <hr>
    <h5>Choose dashboard theme</h5>
    <div class="row">
      <div class="col-4" *ngFor="let t of availableThemes">
        <div class="card">
          <div [class]="'card-body themeCard text-center ' + t.class" [ngClass]="{'active': theme.name === t.name, 'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" (click)="switchTheme(t)">
            <div class="card-title">{{ t.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <br>
  </ng-template>

  <ng-template #newContactModal>
    <div class="form-row">
      <div class="form-inline form-group">
        <label>This contact will be &nbsp;</label>
        <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
          <label for="orgToggle" class="btn btn-sm btn-light"
            [ngClass]="{'active': contactPaneHandle.singlePaneData.individual, 'inactive': !contactPaneHandle.singlePaneData.individual}"
            (click)="contactPaneHandle.singlePaneData.individual = true"><i class="fal fa-user"></i>&nbsp;an Individual
            <input type="radio" required name="orgToggle" autocomplete="off" id="orgToggle" [value]="true"
              [(ngModel)]="contactPaneHandle.singlePaneData.individual">
          </label>
          <label for="orgToggle2" class="btn btn-sm btn-light"
            [ngClass]="{'active': !contactPaneHandle.singlePaneData.individual, 'inactive': contactPaneHandle.singlePaneData.individual}"
            (click)="contactPaneHandle.singlePaneData.individual = false">an Organization&nbsp;<i class="fal fa-briefcase"></i>
            <input type="radio" required name="orgToggle" id="orgToggle2" autocomplete="off" [value]="false"
              [(ngModel)]="contactPaneHandle.singlePaneData.individual">
          </label>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #editUserModal>
    <div>
      <lib-account-management
      [userId]="this.editUserId"
      [userDashDataService]="this.userSvc"
      [contactDashDataService]="this.contactDashSvc"
      [isAdmin]="this.isAdmin()"
      accentColor="#1b1b1b"
      [subscriptionBasedApp]="false"
      [passwordScorerFn]="checkPasswordScore"
      [isSelfChange]="editUserId == currentLoggedInUser.uid"
      [darkMode]="appGlobals.getStoredDarkModeSetting()"
      [glassMode]="appGlobals.getStoredGlassModeSetting()"
      (messageEmitter)="this.sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
      (requestRecordHistoryEmitter)="handleRecordHistoryRequest($event)"
      (refreshTokenRequested)="refreshUserToken()"
      ></lib-account-management>
    </div>
  </ng-template>

 <br>
 <br>
 <br>
 <br>
 <br>
 <br>
 <br>
 <br>
 <br>
 <br>
</main>

<ng-template #uidCol let-contact>
  <td class="recordVal">
    {{ contact.contactUID }}
  </td>
</ng-template>

<ng-template #endCols let-contact>
  <td class="recordVal" *ngIf="!this.appGlobals.site.paymentsActive">
    {{ contact.certofInsuranceRequired ? (contact.certOfInsuranceExpDate | date: 'MM/dd/yyyy':'MST') : '' }}
  </td>
  <td class="recordVal" *ngIf="this.appGlobals.site.paymentsActive" style="width: 7.5em; padding-right: 1em;" [style]="' text-align: ' + (contact.accountCredit > 0 ? 'right' : 'center') + ';'">
    <span style="text-align: left; float: left;" *ngIf="contact.accountCredit > 0">$</span>{{ (contact.accountCredit > 0 ? (contact.accountCredit | number: '1.2-2') : '-') }}
  </td>
  <td class="recordVal">
    {{ contact.materialsTestRequired ? (contact.materialsTestExpDate | date: 'MM/dd/yyyy':'MST') : '' }}
  </td>
  <td class="recordVal">
    {{ contact.saExecutedDate ? (contact.saExecutedDate | date: 'MM/dd/yyyy':'MST') : '' }}
  </td>
</ng-template>

<!--<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="createContactWizOpen" [style.border-color]="contactDashModule.boxMainColor" style="width: 80%; height: auto; padding: 0;">
  <lib-create-contact-wizard #contactWizard *ngIf="createContactWizOpen"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [contactTypes]="preLoadContactTypes"
    [contactHeaderOveride]="customerOverride"
    (wizardCompletedEmitter)="handleContactWizard($event)"
    (wizardSoftCompletionEmitter)="handleContactWizard($event, true)"
    (wizardCancelledEmitter)="handleContactWizard(null)"
    (initializedEmitter)="prepContactWizard()">
    <i [ngClass]="'fal ' + contactDashModule.boxMainIconClass" [style.color]="contactDashModule.boxMainColor" style="padding-right: 0.25em;"></i>
    <strong [style.color]="contactDashModule.boxMainColor">Create New Contact {{ contactWizard.createContactWizard && contactWizard.createContactWizard.currentStep > 0 ? ' - ' + (contactWizard.createContactWizard.currentObject.individual ? (contactWizard.createContactWizard.currentObject.firstName ? contactWizard.createContactWizard.currentObject.firstName + ' ' : '') + contactWizard.createContactWizard.currentObject.lastName : contactWizard.createContactWizard.currentObject.organization) : '' }}</strong>
    <i *ngIf="contactWizard.createContactWizard && contactWizard.createContactWizard.currentStep> 0" [ngClass]="contactWizard.createContactWizard.currentObject.individual ? 'fal fa-user' : 'fal fa-briefcase'" [style.color]="contactDashModule.boxMainColor" style="padding-left: 0.25em;"></i>
  </lib-create-contact-wizard>
</div>-->

<!-- <div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="createKioskAccountWizOpen" [style.color]="kioskDashModule.boxMainColor" style="width: 80%; height: auto; padding: 0;">
  <lib-kiosk-account-wizard *ngIf="createKioskAccountWizOpen"
    [mainColor]="kioskDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [vehicleTypes]="vehicleTypes"
    [customers]="activeCustomers"
    [jobCodes]="jobCodes"
    [jobCategories]="jobCategories"
    [sites]="sites"
    [kioskSvc]="kioskSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobals]="appGlobals"
    (wizardCompletedEmitter)="handleScaleTicketWizard($event)"
    (wizardCancelledEmitter)="handleScaleTicketWizard($event)">
      <i [ngClass]="'fal ' + kioskDashModule.boxMainIconClass" [style.color]="kioskDashModule.boxMainColor"></i>
      <strong [style.color]="kioskDashModule.boxMainColor">Create New Kiosk Account</strong>
  </lib-kiosk-account-wizard>
</div> -->

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="createScaleTicketWizOpen" [style.color]="sthDashModule.boxMainColor" style="width: 80%; height: auto; padding: 0;">
  <lib-scaleticket-wizard *ngIf="createScaleTicketWizOpen"
    [mainColor]="sthDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [vehicleTypes]="vehicleTypes"
    [customers]="activeCustomers"
    [jobCodes]="jobCodes"
    [jobCategories]="jobCategories"
    [sites]="sites"
    [jobSvc]="jobDashSvc"
    [rateSvc]="rateSvc"
    [vehicleSvc]="vehicleSvc"
    [kioskSvc]="kioskSvc"
    [scaleLinkSvc]="scaleLinkSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobals]="appGlobals"
    (wizardCompletedEmitter)="handleScaleTicketWizard($event)"
    (wizardCancelledEmitter)="handleScaleTicketWizard($event)">
      <i [ngClass]="'fal ' + sthDashModule.boxMainIconClass" [style.color]="sthDashModule.boxMainColor"></i>
      <strong [style.color]="sthDashModule.boxMainColor">Create New Scale Ticket</strong>
  </lib-scaleticket-wizard>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="createInvoiceWizOpen" [style.color]="invoiceDashModule.boxMainColor" style="width: 90%; height: auto; padding: 0;">
  <lib-invoice-wizard *ngIf="createInvoiceWizOpen"
    [mainColor]="invoiceDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [customers]="customers"
    [jobCodes]="jobCodes"
    [jobCategories]="jobCategories"
    [sites]="sites"
    [sthSvc]="sthSvc"
    [invoiceSvc]="invoiceSvc"
    [emailSvc]="contactEmailSvc"
    [jobSvc]="jobDashSvc"
    [sbSvcProvider]="sbSvcProvider"
    [appGlobals]="appGlobals"
    (wizardCompletedEmitter)="handleInvoiceWizard($event)"
    (wizardCancelledEmitter)="handleInvoiceWizard($event)">
    <i [ngClass]="'fal ' + invoiceDashModule.boxMainIconClass" [style.color]="invoiceDashModule.boxMainColor" style="padding-right: 0.25em;"></i>
    <strong [style.color]="invoiceDashModule.boxMainColor">Generate New Invoice</strong>
  </lib-invoice-wizard>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="dashModule wizards" *ngIf="createInvoiceBatchWizOpen" [style.color]="invoiceDashModule.boxMainColor" style="width: 90%; height: auto; padding: 0;">
  <lib-invoice-batch-wizard *ngIf="createInvoiceBatchWizOpen"
    [mainColor]="invoiceDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [jobCodes]="jobCodes"
    [jobCategories]="jobCategories"
    [sites]="sites"
    [sthSvc]="sthSvc"
    [contactSvc]="contactDashSvc"
    [jobSvc]="jobDashSvc"
    [invoiceSvc]="invoiceSvc"
    [emailSvc]="contactEmailSvc"
    [appGlobals]="appGlobals"
    [sbSvcProvider]="sbSvcProvider"
    (wizardCompletedEmitter)="handleInvoiceBatchWizard($event)"
    (wizardCancelledEmitter)="handleInvoiceBatchWizard($event)">
    <i [ngClass]="'fal ' + invoiceDashModule.boxMainIconClass" [style.color]="invoiceDashModule.boxMainColor" style="padding-right: 0.25em;"></i>
    <strong [style.color]="invoiceDashModule.boxMainColor">Generate New Invoice Batch</strong>
  </lib-invoice-batch-wizard>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="batchUploaderOpen" [style.color]="invoiceDashModule.boxMainColor" style="width: 80%; height: auto; padding: 0; background-color: inherit;">
  <lib-invoice-batch-upload #batchUploader
    [boxMainIconClass]="invoiceDashModule.boxMainIconClass"
    [invoiceUploadBatch]="invoiceUploadBatch"
    [invoiceBatch]="invoiceBatch"
    [invoiceSvc]="invoiceSvc"
    [batchSvc]="invoiceBatchSvc"
    [sbSvcProvider]="sbSvcProvider"
    (uploaderClosedEmitter)="batchUploadCompleted()">
  </lib-invoice-batch-upload>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="statementEmailerOpen" [style.color]="invoiceDashModule.boxMainColor" style="width: 80%; height: auto; padding: 0; background-color: inherit;">
  <lib-customer-statement-batch #batchUploader *ngIf="statementEmailerOpen"
    [boxMainIconClass]="contactDashModule.boxMainIconClass"
    [contactBatch]="customerSelectItems"
    [contactSvc]="contactDashSvc"
    [contactEmailSvc]="contactEmailSvc"
    [sbSvcProvider]="sbSvcProvider"
    (uploaderClosedEmitter)="finishCustomerStatment()">
  </lib-customer-statement-batch>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="createPaymentWizOpen" [style.color]="paymentDashModule.boxMainColor" style="width: 90%; height: 95%; padding: 0;">
  <lib-payment-wizard *ngIf="createPaymentWizOpen" #paymentWizardComponentRef
    [mainColor]="paymentDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [ticket]="ticket"
    [job]="job"
    [sthSvc]="sthSvc"
    [scaleTicketMode]="stMode"
    [invoice]="invoice"
    [invoiceMode]="invMode"
    [hideACHPaymentOption]="hideACHPaymentOption"
    [invoiceSvc]="invoiceSvc"
    [paymentSvc]="paymentSvc"
    [payPendSvc]="payPendSvc"
    [appGlobals]="appGlobals"
    [sbSvcProvider]="sbSvcProvider"
    [showAll]="true"
    [cloverAppMarketLink]="cloverAppMarketUrl"
    [paymentSvc]="paymentSvc"
    [prepayMode]="prepayMode"
    [contactSvc]="contactDashSvc"
    [forteSvc]="forteSvc"
    [voucherSvc]="voucherSvc"
    [overlaySvc]="overlaySvc"
    [modalSvc]="modalSvc"
    [cd]="cd"
    (wizardCompletedEmitter)="handlePaymentWizard($event)"
    (wizardCancelledEmitter)="handlePaymentWizard($event)">
    <i [ngClass]="'fal ' + paymentDashModule.boxMainIconClass" [style.color]="paymentDashModule.boxMainColor" style="padding-right: 0.25em;"></i>
    <strong [style.color]="paymentDashModule.boxMainColor">{{prepayMode ? "Create Prepayment" : "Create Payment" }}</strong>
  </lib-payment-wizard>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting(), 'glassMode': appGlobals.getStoredGlassModeSetting()}" class="wizards" *ngIf="createEODWizOpen" [style.color]="eodDashModule.boxMainColor" style="width: 90%; height: 90%; padding: 0;">
  <lib-eod-batch-wizard *ngIf="createEODWizOpen"
    [mainColor]="eodDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [appGlobals]="appGlobals"
    [sbSvcProvider]="sbSvcProvider"
    [sthSvc]="sthSvc"
    [invoiceSvc]="invoiceSvc"
    [paymentSvc]="paymentSvc"
    [eodSvc]="eodBatchSvc"
    [dp]="dp"
    (wizardCompletedEmitter)="handleEODWizard($event)"
    (wizardCancelledEmitter)="handleEODWizard($event)">
    <i [ngClass]="'fal ' + eodDashModule.boxMainIconClass" [style.color]="eodDashModule.boxMainColor" style="padding-right: 0.25em;"></i>
    <strong [style.color]="eodDashModule.boxMainColor">Generate EOD Batch</strong>
  </lib-eod-batch-wizard>
</div>

<ng-template #ctAssignModal>
  <div *ngIf="!(contactDashSvc.contactTypeDataStore$ | async).length; else massCTLoaded">
    Please wait...
  </div>
  <ng-template #massCTLoaded>
    <p>
      Ready to adjust {{ massContactsUIDs.length }} Contact records.
    </p>
    <label for="ctDropupMenu" class="form-label">
      Choose multiple
    </label>
    <div class="btn-group dropdown ms-1">
      <button type="button" id="ctDropupMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        class="btn btn-sm dropdown-toggle"
        [ngClass]="{'btn-dark': appGlobals.getStoredDarkModeSetting(), 'btn-light': appGlobals.getStoredGlassModeSetting(), 'btn-outline-secondary': !appGlobals.getStoredDarkModeSetting() && !appGlobals.getStoredGlassModeSetting()}">
        Contact Types
      </button>
      <div class="dropdown-menu" style="max-height: 200px; overflow: auto;" aria-labelledby="ctDropupMenu">
        <a class="dropdown-item" *ngFor="let ctd of (contactDashSvc.contactTypeDataStore$ | async)" (click)="toggleObjectInArray(massCTs, ctd)">
          <i class="fal fa-check me-1" *ngIf="massCTs.includes(ctd)"></i>
          <span class="contactTypeBadge" [libContactTypeBadge]="ctd.color" [deletable]="false">
            {{ ctd.contactTypeDescription }}
          </span>
        </a>
      </div>
    </div>
    <label class="form-label">
      to {{ massCTRemoveMode ? 'remove' : 'add' }}.
    </label>
    <hr class="mt-3">
    <h6 *ngIf="massCTs.length">When you press Save, {{ massCTs.length }} <em>Contact Type(s)</em> will be {{ massCTRemoveMode ? 'removed from' : 'added to' }} each chosen <em>Contact</em>.</h6>
  </ng-template>
</ng-template>

<ng-template #sendEmailModal>
  <p>
    To: <span class="badge badge-pill" [matTooltip]="sendingEmailAddress" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false">{{ sendingEmailAddress.includes(',') ? sendingEmailAddress.split(',').length + ' recipients' : sendingEmailAddress }}</span>
    <br>
    Subject: <input type="text" #subjectForEmail placeholder="Enter a subject line" class="form-control">
    <br>
    <textarea id="textForEmail" #textForEmail class="form-control emailForm" name="textForEmail" placeholder="Type your message"></textarea><br>
  </p>
</ng-template>

<ng-template #paymentInfoModal>
  <div class="row">
    <label style="padding-left: 1em"><b>Payment #{{payment.paymentNumber}}</b> successfully created.</label>
  </div>
  <div class="row">
    <label style="padding-left: 1em"><b>Invoice #{{payment.invoices[0].invoiceNumber}}</b> generated using <b>Tickets {{paymentTicketNumbers}}</b> </label>
  </div>
  <div class="row">
    <div style="width: 100%; padding: 1em;">
      <table style="margin: auto;" class="payment">
        <thead class="payment">
          <th class="payment">Payment Type</th>
          <th class="payment">Name</th>
          <th class="payment">Type/#</th>
          <th class="payment">Amount</th>
        </thead>
        <tbody class="payment">
          <tr class="payment">
            <td class="payment">Cash</td>
            <td class="payment"></td>
            <td class="payment"></td>
            <td class="payment" [ngClass]="{'cash': (payment.cashAmount > 0) || !(payment.totalAmountPaid > 0) || payment.cashBack > 0}"><span style="float: left;">$</span>{{getCashDisplay(payment, 1)}}</td>
          </tr>
          <tr class="payment">
            <td class="payment">Card</td>
            <td class="payment">{{payment.cardName}}</td>
            <td class="payment">{{ getCardTypeText(payment.cardType)}}</td>
            <td class="payment" [ngClass]="{'cash': payment.cardAmount > 0}"><span style="float: left;">$</span>{{getCashDisplay(payment, 2)}}</td>
          </tr>
          <tr class="payment">
            <td class="payment last bottom">Check</td>
            <td class="payment bottom">{{payment.checkName}}</td>
            <td class="payment">{{payment.checkNumber}}</td>
            <td class="payment" [ngClass]="{'cash': payment.checkAmount > 0}"><span style="float: left;">$</span>{{getCashDisplay(payment, 3)}}</td>
          </tr>
          <tr class="payment" *ngIf="payment.appliedCredit > 0">
            <td class="payment">Applied Credit</td>
            <td class="payment"></td>
            <td class="payment"></td>
            <td class="payment" [ngClass]="{'cash': (payment.appliedCredit > 0)}"><span style="float: left;">$</span>{{payment.appliedCredit | number: '1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot class="payment">
          <tr class="payment">
            <th colspan="3" style="text-align: end; padding-right: 0.5em;
            background-color: #B5A49D;
            color: #FFF;
            border-top: solid black 1px;
            border-bottom-left-radius: 6px;">Total Paid: </th>
            <td class="payment" [ngClass]="{'cash': payment.totalAmountPaid > 0}"><span style="float: left;">$</span>{{getCashDisplay(payment, 4)}}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</ng-template>


<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" class="dashModule wizards" *ngIf="customerSelectOpen" [style.color]="contactDashModule.boxMainColor" [style.background-color]="appGlobals.getStoredDarkModeSetting() ? '#333' : '#FFF'" style="width: 80%; height: auto; padding: 0;">
  <i class="fal fa-envelope" [style.color]="contactDashModule.boxMainColor" style="padding: 0 0.25em; font-size: 2em;"></i>
  <strong [style.color]="contactDashModule.boxMainColor" style="font-size: 2em">Send Customer Statement Batch Email</strong>
  <div style="padding: 0 1em;">
    <lib-customer-select #customerSelect *ngIf="customerSelectOpen"
      [mainColor]="contactDashModule.boxMainColor"
      [darkMode]="appGlobals.getStoredDarkModeSetting()"
      [glassMode]="appGlobals.getStoredGlassModeSetting()"
      [tooltipDelay]="tooltipDelay"
      [currentCustomers]="customers"
      [batchMode]="false"
      [isReport]="false"
      [selectMode]="true"
      [customerSvc]="contactDashSvc"
      (selectionEmitter)="selectCustomer($event)"
      (selectionUpdatedEmitter)="selectAllCustomers($event)">
      Select Customers
    </lib-customer-select>
  </div>
  <div class="d-flex btn-group" style="width: 100%;">
    <button class="btn btn-outline-warning" style="float: center; border-width: 5px;"
      type="button" (click)="closeCustomerSelect()">
      <i class="fal fa-times"></i>
      Close
    </button>
    <button class="btn btn-outline-success"
      type="button" style="border-width: 5px;"
      (click)="finishCustomerSelect()">
      <i class="fal fa-check"></i>
      Send Batch Email
    </button>
  </div>
</div>

<div [ngClass]="{'darkMode': appGlobals.getStoredDarkModeSetting()}" class="wizards" *ngIf="emailSelectOpen" [style.color]="contactDashModule.boxMainColor" [style.background-color]="appGlobals.getStoredDarkModeSetting() ? '#333' : '#FFF'" style="width: 80%; height: auto; padding: 0;">
  <lib-email-select *ngIf="emailSelectOpen"
    [mainColor]="contactDashModule.boxMainColor"
    [darkMode]="appGlobals.getStoredDarkModeSetting()"
    [glassMode]="appGlobals.getStoredGlassModeSetting()"
    [tooltipDelay]="tooltipDelay"
    [currentEmails]="selectedEmails"
    [selectedCustomer]="contactForStatement"
    [appGlobals]="appGlobals"
    [sbSvcProvider]="sbSvcProvider"
    [emailSvc]="contactEmailSvc"
    modelType= "Customer Statement"
    (selectionEmitter)="selectEmail($event)"></lib-email-select>
    <div class="row justify-content-end" style="width: 100% !important; margin: 0;">
      <div class="btn-group w-100 m-0" style="border-bottom: none;" role="group">
        <button type="button" aria-label="Cancel Selection" (click)="cancelEmailSelect()" class="btn wizardBtn wizardBtn-cancel" matTooltip="Cancel Selection"
          [ngClass]="{'btn-warning': appGlobals.getStoredDarkModeSetting() , 'btn-outline-warning': !appGlobals.getStoredDarkModeSetting() && !appGlobals.getStoredGlassModeSetting(), 'btn-light': appGlobals.getStoredGlassModeSetting()}">
          <i class="fa-lg fa-window-close mr-1" [ngClass]="{'fas': appGlobals.getStoredDarkModeSetting(), 'fal': !appGlobals.getStoredDarkModeSetting()}"></i>
          Cancel
        </button>
        <button type="submit" aria-label="Finish Selection" (click)="confirmEmailSelect()" class="btn wizardBtn wizardBtn-next"
          [ngClass]="{'btn-success': appGlobals.getStoredDarkModeSetting(), 'btn-outline-success': !appGlobals.getStoredDarkModeSetting() && !appGlobals.getStoredGlassModeSetting(), 'btn-light': appGlobals.getStoredGlassModeSetting()}" matTooltip="Confirm Selection">
          <i class="fa-check fa-lg ms-1" [ngClass]="{'fas': appGlobals.getStoredDarkModeSetting(), 'fal': !appGlobals.getStoredDarkModeSetting()}"></i>
          Confirm
        </button>
      </div>
    </div>
</div>

<lib-scalelink-viewer-modal [isAdmin]="isAdmin()"></lib-scalelink-viewer-modal>


<ng-template #emptyButtonOverrideTemplate></ng-template>
<ng-template #locationSelectModal>
  <ul class="list-group list-group-flush">
    <li [class.active]="appGlobals.selectedLocation?.uid === location.uid" class="list-group-item list-group-item-action" *ngFor="let location of appGlobals.availableLocations"
        (click)="selectActiveLocation(location, false)"
        style="cursor: pointer; text-align: center;">
      {{ location.locationName }}
    </li>
  </ul>

  <ul class="list-group list-group-flush" *ngIf="appGlobals.hasAccessToAllLocationData">
    <li class="list-group-item list-group-item-action"(click)="selectActiveLocation(null, true)" style="cursor: pointer; text-align: center;">
      All Locations
    </li>
  </ul>
</ng-template>
